import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { GetLicensedProductsQuery } from './graphql/GetLicensedProductsQuery.graphql.ts';
import type { GetLicensedProductsQuery as GetLicensedProductsQueryType } from './graphql/__types__/GetLicensedProductsQuery.ts';

export async function preloadGlobalAppShortcutsLicensedProducts() {
	const { cloudId } = getPreloaderFnContext();

	return query<GetLicensedProductsQueryType, { cloudId: string }>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: GetLicensedProductsQuery,
		variables: { cloudId },
	});
}
